import {
  resolveTariffDisabledReason,
  resolveTariffTargetIds,
  TariffTargetDelivery,
} from 'src/components/dispatch/tariffCalculationAvailability';

export type LongHaulTariffInput = {
  deliveries: TariffTargetDelivery[];
  /** 配車データの取得中・取得失敗 */
  isLoading: boolean;
  isError: boolean;
  /** 自動配車 controller の実行中（D&D の自動保存もここに入る） */
  isBusy: boolean;
  /** 「未割当に戻す」の実行中 */
  isResetting: boolean;
  /** 運賃計算そのものの実行中。押し直せると同じ計算が二重に走る */
  isCalculatingTariff: boolean;
};

/**
 * 長距離配車の運賃計算の可否。
 *
 * Why not `/map` の `resolveMapTariffAvailability` をそのまま使う: あちらは
 * Container が導出した取得系の理由を文字列 1 本で受け取る形で、長距離の Presenter は
 * query の状態を直接持っている。渡すものが違うので入口だけ分け、判定そのもの
 * （`resolveTariffTargetIds` / `resolveTariffDisabledReason`）は共有する。
 *
 * Why not 表示対象の絞り込みを見る: この画面は配送形態・区間種別の絞り込みを出さない。
 */
export function resolveLongHaulTariffAvailability(input: LongHaulTariffInput): {
  targetIds: number[];
  disabledReason: string | null;
} {
  const targetIds = resolveTariffTargetIds(input.deliveries);
  return {
    targetIds,
    disabledReason: resolveTariffDisabledReason({
      isError: input.isError,
      isFetching: input.isLoading,
      // isResetting を先に見る（`/map` と同じ優先順位。isBusy は resetting を内包するため、
      // 逆にすると「未割当に戻す」の最中に「自動配車の実行中です」と嘘をつく）
      hasUnsettledChange: input.isResetting || input.isBusy || input.isCalculatingTariff,
      unsettledReason: (input.isResetting && '配車を変更中です')
        || (input.isBusy && '自動配車の実行中です')
        || (input.isCalculatingTariff && '運賃計算の実行中です')
        || '未確定の変更があります',
      targetCount: targetIds.length,
    }),
  };
}

/**
 * D&D の確定は最後の操作から 2 秒後に飛ぶ（`useDispatchAssignment` の debounce）。
 * その待ち時間は `isBusy` にならないので、押した瞬間に ref を見て止める。
 *
 * Why not disabled にする: ref は再描画を起こさないので、ボタンの見た目には反映できない。
 * `/map` とカード配車にこの待ち時間は無く、長距離だけが持つ状態。
 */
export const PENDING_ASSIGNMENT_TARIFF_REASON = '配車の保存を待っています。少し待ってから実行してください';
